var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfiles = function SvgProfiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M44.524 50.952C58.594 50.952 70 39.546 70 25.476S58.594 0 44.524 0 19.048 11.406 19.048 25.476c0 2.73.429 5.359 1.223 7.824a9.5 9.5 0 0 1 4.967-1.395 9.52 9.52 0 0 1 9.524 9.524 9.5 9.5 0 0 1-2.47 6.4 25.36 25.36 0 0 0 12.232 3.123",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M40.611 59.856C51.981 57.3 60.476 47.142 60.476 35 60.476 20.93 49.07 9.524 35 9.524S9.524 20.93 9.524 35c0 8.784 4.445 16.53 11.21 21.11 1.656-.264 3.211-.396 4.504-.396 4.189 0 11.127 1.386 15.373 4.142m-5.85-18.427a9.52 9.52 0 0 1-9.523 9.523 9.52 9.52 0 0 1-9.524-9.523 9.52 9.52 0 0 1 9.524-9.524 9.52 9.52 0 0 1 9.524 9.524",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M43.468 62.56a25.4 25.4 0 0 0 7.484-18.036c0-14.07-11.406-25.476-25.476-25.476S0 30.454 0 44.524a25.4 25.4 0 0 0 7.202 17.75c3.13-4.364 12.762-6.56 18.036-6.56 5.388 0 15.325 2.292 18.23 6.847M34.762 41.43a9.52 9.52 0 0 1-9.524 9.523 9.52 9.52 0 0 1-9.524-9.523 9.52 9.52 0 0 1 9.524-9.524 9.52 9.52 0 0 1 9.524 9.524",
    clipRule: "evenodd"
  })));
};
export default SvgProfiles;